import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ProductListing, ProductAddEdit } from './Pages';

export const ProductRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={ProductListing} />
        <Route exact path={`${match.path}/AddEdit`} component={ProductAddEdit} />
    </Fragment>
)